export default "__VITE_ASSET__CC8pUrzI__"